exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countryRegionCityLoading[data-v-5a5cf4b0]{height:35px;overflow:hidden;text-align:center}", ""]);

// exports
